module.exports = __webpack_public_path__ + "static/media/user.e311d1b2.jpg";